import { render } from "./PosterComponent.vue?vue&type=template&id=8cea454c"
import script from "./PosterComponent.vue?vue&type=script&lang=ts"
export * from "./PosterComponent.vue?vue&type=script&lang=ts"

import "./PosterComponent.vue?vue&type=style&index=0&id=8cea454c&lang=scss"
script.render = render

export default script